module.exports = __webpack_public_path__ + "img/bul_layout_footer.d3c03646.svg";